import React, { useState } from "react";
import "../../styles/FilterModal.css";
import { translateLabel, useTranslationSnapshot } from "./../../translations/runtime";


const CATEGORIES = [
  "Restaurants",
  "Groceries",
  "Cosmetics",
  "Home",
  "Bakery",
  "Dairy",
  "Cuisine Types",
  "Others",
];
const REGIONS = ["Bednayel", "Baalbek", "Zahle", "Niha"];

function FilterModal({ initialFilters, onClose, onApply }) {
  useTranslationSnapshot();
  const [activeTab, setActiveTab] = useState("category");
  const [selectedCategories, setSelectedCategories] = useState(
    initialFilters?.categories || [],
  );
  const [selectedRegions, setSelectedRegions] = useState(
    initialFilters?.regions || [],
  );

  const toggleCategory = (cat) => {
    setSelectedCategories((prev) => (prev.includes(cat) ? [] : [cat]));
  };

  const toggleRegion = (region) => {
    setSelectedRegions((prev) => (prev.includes(region) ? [] : [region]));
  };

  const handleApply = () => {
    onApply({ categories: selectedCategories, regions: selectedRegions });
    onClose();
  };

  const handleClear = () => {
    onApply({ categories: [], regions: [] });
    onClose();
  };

  return (
    <div className="filter-modal-overlay" onClick={onClose}>
      <div className="filter-modal-container" onClick={(e) => e.stopPropagation()}>

        <div className="filter-modal-header">
          <div className="filter-modal-title">Filters</div>
          <div className="filter-modal-close" onClick={onClose}>✕</div>
        </div>

        <div className="filter-modal-tabs">
          <div
            className={`filter-modal-tab ${activeTab === "category" ? "filter-modal-tab-active" : ""}`}
            onClick={() => setActiveTab("category")}
          > {translateLabel("btn_category", "Category")} </div>
          <div
            className={`filter-modal-tab ${activeTab === "region" ? "filter-modal-tab-active" : ""}`}
            onClick={() => setActiveTab("region")}
          > {translateLabel("txt_admin_region", "Region")} </div>
        </div>

        <div className="filter-modal-body">
          {activeTab === "category" && (
            <div className="filter-modal-section">
              <div className="filter-modal-section-title">{translateLabel("btn_category", "Category")}</div>
              <div className="filter-modal-options">
                {CATEGORIES.map((cat) => (
                  <div key={cat} className="filter-modal-option" onClick={() => toggleCategory(cat)}>
                    <div className={`filter-modal-checkbox ${selectedCategories.includes(cat) ? "filter-modal-checkbox-checked" : ""}`} />
                    <div className="filter-modal-option-label">{cat}</div>
                  </div>
                ))}
              </div>
            </div>
          )}

          {activeTab === "region" && (
            <div className="filter-modal-section">
              <div className="filter-modal-section-title">{translateLabel("txt_admin_region", "Region")}</div>
              <div className="filter-modal-select-wrapper">
                <div className="filter-modal-select-label">Select your Region</div>
                <div className="filter-modal-select-arrow">▾</div>
              </div>
              <div className="filter-modal-options">
                {REGIONS.map((region) => (
                  <div key={region} className="filter-modal-option" onClick={() => toggleRegion(region)}>
                    <div className={`filter-modal-checkbox ${selectedRegions.includes(region) ? "filter-modal-checkbox-checked" : ""}`} />
                    <div className="filter-modal-option-label">{region}</div>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>

        <div className="filter-modal-footer">
          <button
            className="filter-modal-button filter-modal-button-clear"
            type="button"
            onClick={handleClear}
          > {translateLabel("txt_business_clear", "Clear")} </button>
          <button
            className="filter-modal-button filter-modal-button-apply"
            type="button"
            onClick={handleApply}
          > {translateLabel("txt_business_apply", "Apply")} </button>
        </div>

      </div>
    </div>
  );
}

export default FilterModal;
